import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import formTheme from '../../styles/formTheme';
var DobDivider = styled.div.withConfig({
  displayName: "DobDivider",
  componentId: "nal64f-0"
})(["&:after{color:", ";content:'/';display:inline-block;transform:translateY(-2px);transition:opacity 0.3s ease-in;}", ""], function (props) {
  return transparentize(0.4, _get(props, "theme.form.input[" + props.skin + "].color", formTheme.form.input[props.skin].color));
}, function (props) {
  return props.disabledValue && css(["&:after{color:", ";}"], _get(props, "theme.form.input[" + props.skin + "].colorDisabled", formTheme.form.input[props.skin].colorDisabled));
});
export default DobDivider;